export default "https://cdn-static.gokick.com/assets/7e8bc23aa9277111cd73fa77d581d1f801b67d5a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";